<template>
    <div>
        <div class="mb-3">
            <div class="font-weight-bold h3">
                {{ __('sale.delivery_note_info.businessAddress') }}
            </div>
            <div>
                {{ __('sale.delivery_note_info.differs') }}
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <FormGroupNew :label="__('validation.attributes.street1')"
                              :error="value.errors.businessStreet">
                    <input type="text"
                           class="form-control"
                           placeholder="Musterstrasse 35"
                           v-model="localForm.businessStreet">
                </FormGroupNew>
            </div>
            <div class="col-md-6">
                <FormGroupNew :label="__('general.postcode')"
                              :error="value.errors.businessPostal"
                >
                    <input type="text"
                           class="form-control"
                           placeholder="35460"
                           v-model="localForm.businessPostal">
                </FormGroupNew>
            </div>
            <div class="col-md-6">
                <FormGroupNew :label="__('general.city')"
                              :error="value.errors.businessCity"
                >
                    <input type="text"
                           class="form-control"
                           placeholder="Musterstadt"
                           v-model="localForm.businessCity">
                </FormGroupNew>
            </div>
        </div>
    </div>
</template>

<script>
import FormGroupNew from "@components/Form/FormGroupNew.vue";

export default {
    components: {FormGroupNew},

    props: {
        value: Object
    },

    data() {
        return {
            localForm: this.value
        };
    },

    watch: {
        localForm: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue)
            }
        }
    }
}
</script>
